import React from "react";
import supStyles from "../atoms/Superscript/Superscript.module.scss";
import { scrollView } from "../../libs/scrollView";
import { fireSupGA } from "../../hooks/tagging";

export default {
	english: {
		evergreen: {
			headline: <>You do money your&nbsp;way. We can help make it&nbsp;simpler.</>,
			alt: "A confident, smiling man walks down a busy city sidewalk in front of a store window.",
			class: "bgEG"
		},
		dynamic: [
			{
				headline: <>Monitor subscriptions to stay&nbsp;on&nbsp;track? <br/>We can help with&nbsp;that.</>,
				alt: "A seated man with headphones around his neck looks thoughtfully at his mobile phone.",
				class: "bg0"
			},
			{
				headline: <>Helping your kid spend money smart? We're all for it.</>,
				alt: "",
				class: "bg1"
			},
			{
				headline: <>Want to track your spending like a pro?  <br />We&nbsp;got&nbsp;you.
				</>,
				alt: "A confident, smiling man walks down a busy city sidewalk in front of a store window.",
				class: "bg2"
			},
			{
				headline: <>Ready to get shout outs for saving on the&nbsp;regular?  We're here for you.</>,
				alt: "A woman working out in a gym checks her mobile phone with a satisfied look.",
				class: "bg3"
			},
			{
				headline: <>Got big savings goals in&nbsp;mind? <br/>We can help with&nbsp;that.</>,
				alt: "A hopeful, smiling man sits in his car eating a sandwich as he looks at his mobile phone.",
				class: "bg4"
			},
			{
				headline: <>Helping your kid spend money&nbsp;smart? <br/>We’re all for&nbsp;it.</>,
				alt: "A teenager stands at a convenience store counter making a purchase with a debit card.",
				class: "bg5"
			},
			{
				headline: <>You're in control. Turn your debit card on or off<a id="body-sup-1" className={supStyles.bodySup} href="" aria-label="footnote 1"><sup>1</sup></a> when you decide to.</>,
				alt: "A young man stands in his kitchen and checks his mobile phone with a self-assured look.",
				class: "bg6"
			},

		]
	},
	spanish: {
		evergreen: {
			headline: <>Desde pequeño aprendiste la importancia de manejar tu dinero. <span/>Con Wells Fargo, puedes hacerlo a tu manera.</>,
			alt: "Un joven está de pie en su cocina y revisa su teléfono móvil con una expresión segura de sí mismo.",
			class: "bgEG"
		},
		dynamic: [
			{
				headline: <>ES: Track your subscriptions to save more? We’re on board.</>,
				alt: "",
				class: "bg0"
			},
			{
				headline: <>ES: Invest $10 in a stock fraction instead of take out? Let’s do it.</>,
				alt: "",
				class: "bg1"
			},
			{
				headline: <>ES: Turn your card back on after a spending break? Ready when you are.</>,
				alt: "",
				class: "bg2"
			},
			{
				headline: <>Desde pequeño aprendiste la importancia de proteger tu dinero. Wells Fargo tiene las herramientas para ayudarte a hacerlo con facilidad.</>,
				alt: "Un joven está de pie en su cocina y revisa su teléfono móvil con una expresión segura de sí mismo.",
				class: "bg3"
			},
			{
				headline: <>Desde pequeña aprendiste la importancia de ahorrar. Wells Fargo tiene las herramientas para ayudarte a ahorrar con facilidad.</>,
				alt: "Una joven está sentada en un sofá y usa su teléfono móvil con una sonrisa esperanzadora mientras su abuelo revisa un sobre en el fondo.",
				class: "bg4"
			},
			{
				headline: <>Desde pequeña aprendiste la importancia de manejar tu dinero. Con Wells Fargo puedes hacerlo a tu manera.</>,
				alt: "Una mujer haciendo ejercicio en un gimnasio revisa su teléfono móvil con una mirada de satisfacción.",
				class: "bg5"
			},
		]

	}
};
